import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 半角数のみ, 必須入力, 日付書式} from '@/type/validation/validator';

export interface 譲渡履歴検索条件型 {
    部署コード: string;
    譲渡日付FROM: 日付型;
    譲渡日付TO: 日付型;
    メーカー名: string;
    商品名カナ: string;
    譲渡医療機関コード: string;
    登録者コード: string;
    譲渡伝票番号: number | null;
}

export interface 譲渡履歴検索結果型 {
    譲渡履歴レコード一覧: 譲渡履歴レコード型[];
    アラートメッセージ: string;
}

export interface 譲渡履歴レコード型 {
    譲渡SEQ: number;
    譲渡伝票番号: number;
    譲渡伝票行番号: number;
    譲渡部署名: string;
    譲渡医療機関名: string;
    譲渡担当薬剤師: string;
    有効期限: 日付型;
    ロット番号: string;
    譲渡数: number;
    譲渡単位名: string;
    薬価: number;
    譲渡単価: number;
    消費税パーセント表記: string;
    譲渡金額: number;
    手数料: number;
    備考: string;
    譲渡入力方法: string;
    譲渡日付: 日付型;
    商品名: string;
    規格容量: string;
    メーカー名: string;
    利用者氏名: string;
    読取専用フラグ: string;
}

export type 日付型 = Date | null;

// バリデーション用のマップ
export const 譲渡履歴検索条件バリデータ一覧: Validator[] = [
    {
        name: '商品名カナ',
        constraints: [
            {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
        ],
    },
    {
        name: '譲渡日付FROM',
        constraints: [
            {method: 必須入力, message: '譲渡年月日Fromは入力必須項目です'},
            {method: 日付書式, message: '譲渡年月日Fromの書式を正しく入力してください'},
        ],
    },
    {
        name: '譲渡日付TO',
        constraints: [
            {method: 日付書式, message: '譲渡年月日Toの書式を正しく入力してください'},
        ],
    },
    {
        name: '譲渡伝票番号',
        constraints: [
            {method: 半角数のみ, message: '伝票番号は半角数字で入力してください'},
        ],
    },
];
